import EffectParameterSlider from "components/effects/EffectParameterSlider.js"
import React, { useEffect, useCallback, useState} from 'react';
import ParametersMapper from './ParametersMapper.js';
import {connect} from 'react-redux';
import CheckboxParameter from './CheckboxParameter.js';

const ControlParametersComponent = ({sequencerEngine, effect, valueList, len, index, isDraggable}) => { 
    let list = [... valueList, undefined];
    index = index % valueList.length;
    return (
        <div className="control-parameters accumulator">
          <div className="acc-column">
            {list.map((x, i) => <ListItem isCurrent={i === index} effect={effect} key={i} item={x} i={i}/>)}
            
          </div>
          <ParametersMapper isDraggable={isDraggable} effect={effect}>
            <EffectParameterSlider
              name={'Ramp Time'}
              parameter={effect.rampTimeParameter}
              isParameter={true}
              sequencerEngine={sequencerEngine}
              lfoEnabled={true}
              unit="ms"
              step={1}
              min={1}
              max={3000}/>
            <CheckboxParameter name="Reset on step 1" parameter={effect.resetAtZeroParameter}/>
          </ParametersMapper>
        </div>
    );
};

const ListItem = ({effect, item, i, key, isCurrent}) => {
    let [value, setValue] = useState(item === undefined ? "" : undefined);

    useEffect(() => {
        if (item === undefined) {
            setValue("");
        } else {
            setValue(undefined);
        }
    }, [item, setValue]);

    const onKeyDown = useCallback((e) => {
        if (e.key === 'Enter') {
            let _value = parseFloat(value);
            if (isNaN(_value)) {
                return;
            }
            let _list = effect.valueList;
            if (i === undefined) {
                // add the item
                effect.valueList = [... _list, _value];
            }  else {
                // set the item
                _list[i] = _value;
                effect.valueList = _list;
            }
            setValue(undefined);
        }
    }, [setValue, value, effect, i]);

    const onDelete = useCallback((e) => {
        e.stopPropagation();
        let valueList = [... effect.valueList];
        valueList.splice(i, i);
        effect.valueList = valueList;
    }, [effect, i]);

    if (value !== undefined) {
        return (
            <div className="value-list-item">
              <input
                placeholder="Enter value"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                onKeyDown={onKeyDown}
              />
            </div>
        );
    } else {
        return (
            <div
              onClick={() => setValue(item)}
              className={isCurrent ? "value-list-item current" : "value-list-item"}>
              <div>{item}</div>
              <div onClick={onDelete} className="delete-btn">x</div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    let list = props.effect.listParameter.get();
    return {
        valueList: list,
        len: list.length,
        index: props.effect.counter
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ControlParametersComponent);
